import useGlobalStore from '@/store/useGlobalStore'
import { useRouter } from 'next/router'
import { useEffect } from 'react'

export const useClearCartAfterCountryChange = () => {
  const {
    app: { alpha3 },
    clearCart,
  } = useGlobalStore()

  const router = useRouter()

  useEffect(() => {
    const routerAlpha3 = router.query?.alpha3 as string

    if (!routerAlpha3) return

    if (alpha3.toLocaleLowerCase() !== routerAlpha3?.toLocaleLowerCase()) {
      clearCart()
    }
  }, [router.query?.alpha3, alpha3, clearCart])
}
